// extracted by mini-css-extract-plugin
export default {"adContainer":"AdsList-module-adContainer"};